var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-bg",style:(_vm.rootStyle)},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.imgUrl),expression:"imgUrl"}],style:(_vm.rootStyle),attrs:{"src":_vm.imgUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }